<template>
  <b-row>
  <!-- PRIVATE KEY -->
    <b-col sm="12" class="form-group" >
      <label v-if="!readonly">
        {{ $t('common.security.import_priv_ks') }}
      </label>
    </b-col>
    <b-col sm="6" class="form-group" v-if="!readonly">
      <form-write-group-label-input v-model="name" isMandatory
        :inputLabel="$t('common.security.priv_key_name')">
      </form-write-group-label-input>
    </b-col>
    <b-col sm="6" class="form-group" v-else>
      <form-read-group-label-input isMandatory
        :inputLabel="$t('common.security.priv_key_name')"
        :inputValue="name">
      </form-read-group-label-input>
    </b-col>
    <b-col sm="6" class="form-group" v-if="!readonly">
      <form-write-group-label-input v-model="privateKey" isMandatory
        :inputLabel="$t('common.security.priv_key')">
      </form-write-group-label-input>
    </b-col>
    <b-col sm="6" class="form-group" v-else>
      <form-read-group-label-input isMandatory
        :inputLabel="$t('common.security.priv_key')"
        :inputValue="privateKey">
      </form-read-group-label-input>
    </b-col>
    <b-col sm="6" class="form-group" v-if="!readonly">
      <label for="type">
        {{ $t('common.type_label') }}<span class="color-red"> * </span>
      </label>
      <select class="form-control" v-model="type" id="type">
        <option value="0">{{ $t('common.security.please_select_a_type') }}</option>
        <option value="SMIME">{{ $t('common.security.smime') }}</option>
        <option value="SSL">{{ $t('common.security.ssl') }}</option>
      </select>
    </b-col>
    <b-col sm="6" class="form-group" v-else>
      <form-read-group-label-input isMandatory
        :inputLabel="$t('common.type_label')"
        :inputValue="type">
      </form-read-group-label-input>
    </b-col>
    <b-col cols="4" class="form-group" v-if="this.formType !== 'add' && !readonly">
      <b-checkbox v-model="checkboxChangePass">{{ $t('common.chg_pwd') }}</b-checkbox>
    </b-col>
    <b-col cols="4" class="form-group" v-if="this.formType !== 'add' && !readonly">
      <b-checkbox v-model="checkboxShowPass">{{ $t('common.show_password') }}</b-checkbox>
    </b-col>
    <b-col sm="6" class="form-group" v-if="this.formType === 'add'">
      <form-write-group-label-input v-model="password" isMandatory
        :inputLabel="$t('common.pwd')"
        :inputType="'password'">
      </form-write-group-label-input>
    </b-col>
    <b-col sm="6" class="form-group" v-else-if="!readonly && checkboxChangePass === true">
      <form-write-group-label-input v-model="password" isMandatory
        :inputLabel="$t('common.pwd')"
        :inputType="passwordFieldType">
      </form-write-group-label-input>
    </b-col>
    <b-col sm="6" class="form-group" v-if="this.formType === 'add'">
      <form-write-group-label-input v-model="passwordVerif" isMandatory
        :inputLabel="$t('common.security.verif_password')"
        :inputType="'password'">
      </form-write-group-label-input>
    </b-col>
    <b-col sm="6" class="form-group" v-else-if="!readonly && checkboxChangePass === true">
      <form-write-group-label-input v-model="passwordVerif" isMandatory
        :inputLabel="$t('common.security.verif_password')"
        :inputType="passwordFieldType">
      </form-write-group-label-input>
    </b-col>
    <b-col sm="6" class="form-group" v-if="!readonly">
      <label for="pod">
        {{ $t('common.security.pod') }}<span class="color-red"> * </span>
      </label>
      <select class="form-control" v-model="idPod" id="pod">
        <option v-for="pod in podList" :key="pod.id" :value="pod.name">
          {{ pod.name }}
        </option>
      </select>
    </b-col>
    <b-col sm="6" class="form-group" v-else>
      <form-read-group-label-input
        :inputLabel="$t('common.security.pod')"
        :inputValue="idPod">
      </form-read-group-label-input>
    </b-col>
  </b-row>
</template>
<script>
import formReadGroupLabelInput from '@/components/common/formReadGroupLabelInput.vue'
import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'
import FormAccordion from '@/components/common/FormAccordion.vue'
import {errorMessageAlert} from '@/helpers/alert'

export default {
  name: 'privateKeysFormGlobal',
  components: {
    'form-read-group-label-input': formReadGroupLabelInput,
    'form-write-group-label-input': formWriteGroupLabelInput,
    'form-accordion': FormAccordion
  },
  props: {
    mode: {
      type: String,
      default: 'add'
    },
    placementPrivateKey: {
      type: Number,
      default: -1
    },
    readonly: {
      type: Boolean,
      default: false
    },
    value: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  computed:{
    inputValue: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    },
    name:{
      get () {
        return this.inputValue.name
      },
      set (val) {
        this.inputValue = {
          name: val,
          privateKey: this.inputValue.privateKey,
          type: this.inputValue.type,
          password: this.inputValue.password,
          passwordVerif: this.inputValue.passwordVerif,
          idPod: this.inputValue.idPod
        }
      },
    },
    privateKey:{
      get () {
        return this.inputValue.privateKey
      },
      set (val) {
        this.inputValue = {
          name: this.inputValue.name,
          privateKey: val,
          type: this.inputValue.type,
          password: this.inputValue.password,
          passwordVerif: this.inputValue.passwordVerif,
          idPod: this.inputValue.idPod
        }
      }
    },
    type:{
      get () {
        return this.inputValue.type
      },
      set (val) {
        this.inputValue = {
          name: this.inputValue.name,
          privateKey: this.inputValue.privateKey,
          type: val,
          password: this.inputValue.password,
          passwordVerif: this.inputValue.passwordVerif,
          idPod: this.inputValue.idPod
        }
      }
    },
    password:{
      get () {
        return this.inputValue.password
      },
      set (val) {
        this.inputValue = {
          name: this.inputValue.name,
          privateKey: this.inputValue.privateKey,
          type: this.inputValue.type,
          password: val,
          passwordVerif: this.inputValue.passwordVerif,
          idPod: this.inputValue.idPod
        }
      }
    },
    passwordVerif:{
      get () {
        return this.inputValue.passwordVerif
      },
      set (val) {
        this.inputValue = {
          name: this.inputValue.name,
          privateKey: this.inputValue.privateKey,
          type: this.inputValue.type,
          password: this.inputValue.password,
          passwordVerif: val,
          idPod: this.inputValue.idPod
        }
      }
    },
    idPod:{
      get () {
        return this.inputValue.idPod
      },
      set (val) {
        this.inputValue = {
          name: this.inputValue.name,
          privateKey: this.inputValue.privateKey,
          type: this.inputValue.type,
          password: this.inputValue.password,
          passwordVerif: this.inputValue.passwordVerif,
          idPod: val
        }
      }
    },
    pageTitle () {
      return this.$i18n.t('common.security.priv_key_info') + (this.placementPrivateKey + 1 > 0 ? (' ' + (this.placementPrivateKey)) : '')
    },
  },
  data () {
    return {
      checkboxChangePass: false,
      checkboxShowPass: false,
      formType: 'add',
      passwordFieldType : 'password',
      podList: []
    }
  },
  created () {
    this.formType = this.mode
    if (this.formType === 'create') {
      this.formType = 'add'
    }
    if (this.formType === 'view') {
      this.inputValue.passwordVerif = this.value.password
    }
    this.getPods()
  },
  methods: {
    getPods() {
      let that = this

      this.$engine.firstOn().routing.pod.fetch()
      .then(resp => {
        let podsObject = {}
        podsObject = resp.data.Pods
        that.updatePods(podsObject)
        this.$f7.pullToRefreshDone()
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    toggleVisibility () {
      if (this.passwordFieldType === 'password') {
        this.passwordFieldType = 'text'
      } else {
        this.passwordFieldType = 'password'
      }
    },
    updatePods (podsObject) {
      this.podList = podsObject
    }
  },
  watch: {
    checkboxChangePass () {
      if(this.checkboxChangePass === true) {
        this.inputValue.passwordVerif = ''
      } else {
        this.inputValue.passwordVerif = this.value.password
      }
    },
    checkboxShowPass () {
      this.toggleVisibility()
    },
  }
}
</script>